import {
    CHEMICAL_URI,
    BIO_URI,
    DISCOVERY_URI,
    INSIGHTS_URI,
    ANALYTICS_URI,
    ACCOUNT_URI,
    WORKSPACE_URI,
    DASHBOARD_URI,
    SYNAPSE_URI
} from 'library-@/config/apiConfig';
import { icons } from 'library-@/utils/workspaceIcon';
import img1 from 'library-@/assets/images/covers/dashboard/dashboard-image1.jpg';
import img2 from 'library-@/assets/images/covers/dashboard/dashboard-image2.jpg';
import img3 from 'library-@/assets/images/covers/dashboard/dashboard-image3.jpg';
import img4 from 'library-@/assets/images/covers/dashboard/dashboard-image4.jpg';
import img5 from 'library-@/assets/images/covers/dashboard/dashboard-image5.jpg';
import img6 from 'library-@/assets/images/covers/dashboard/dashboard-image6.jpg';
import img7 from 'library-@/assets/images/covers/dashboard/dashboard-image7.jpg';
import img8 from 'library-@/assets/images/covers/dashboard/dashboard-image8.jpg';
import img9 from 'library-@/assets/images/covers/dashboard/dashboard-image9.jpg';
import img10 from 'library-@/assets/images/covers/dashboard/dashboard-image10.jpg';
import insightsCover from 'library-@/assets/images/covers/insights/cover.png';

export const IS_PROD = process.env.NODE_ENV === 'production';

export const POPPER_OPEN_DELAY = 300;

export const IE9 = /MSIE 9/i.test(navigator.userAgent);

export const IE10 = /MSIE 10/i.test(navigator.userAgent);

export const isMac = /macintosh|mac os x/i.test(navigator.userAgent);

export const isIE = 'onmspointerleave' in window || IE9 || IE10;

// 默认网站语言
export const DEFAULT_SITE_LANG = 'en';

export const PRODUCTS_I18N_MAP = {
    analytics: 'commonNav.analytics',
    patsnap: 'commonNav.patsnap',
    // 后台返回的 analytics
    pro: 'commonNav.analytics',
    discovery: 'commonNav.discovery',
    chemical: 'commonNav.chemical',
    bio: 'commonNav.bio',
    insights: 'commonNav.insights',
    // 后台返回的 insights
    report: 'commonNav.insights',
    innosnap: 'commonNav.innosnap',
    courseToB: 'commonNav.courseToB',
    // 后台返回的 course2b
    course2b: 'commonNav.courseToB',
    courseToC: 'commonNav.courseToC',
    // 后台返回的 courseToC
    course2c: 'commonNav.courseToC',
    synapse: 'commonNav.synapse',
    workspace: 'commonNav.workspace',
    dashboard: 'commonNav.dashboard'
};

export const DISCOVERY_PATH_MAP = {
    'ALL': 'overview',
    'NEWS': 'news-list',
    'MARKET_REPORT': 'market-list',
    'VC_INVESTMENT': 'market-list',
    'MA': 'merger-list',
    'RESEARCH_FUNDING': 'research-funding-list',
    'GRANT': 'grant-list',
    'PATENT': 'patent-list',
    'PAPER': 'paper-list',
    'COMPANY': 'company-list',
    'UNIVERSITY': 'university-list',
    'STARTUP': 'startup-list',
    'EXPERT': 'expert-list',
    'RELATION_MAP': 'relation-ships',
    'TECH_OFFERING': 'technology-offerings-list',
    'CLINICAL_TRIAL': 'clinical-trial-list'
};

export const BIO_PATH_MAP = {
    'CDR': 'search#/results/cdr/${taskId}/${groupId}/mysearch',
    'MOTIF': 'search#/results/motif/${taskId}/${groupId}/mysearch',
    'MOTIF2': 'search#/results/motif/${taskId}/${groupId}/mysearch',
    'FRAGMENT_SIZE': 'search#/results/fragment/${taskId}/${groupId}/mysearch',
    'FRAGMENT_MULTI': 'search#/results/fragment/${taskId}/${groupId}/mysearch',
    'MANUAL': 'search#/results/normal/${taskId}/${groupId}/mysearch',
    'ANTIBODY': 'search#/report/${taskId}',
    'SHORT': 'search#/results/normal/${taskId}/${groupId}',
    'COMBINED': 'search#/combined/${taskId}',
    'MODIFICATION': 'search#/results/modification/${taskId}/${groupId}'
};

export const DASHBOARD_DEFAULT_COVER = [
    { id: '/img/dashboard/dashboard-image1.jpg', src: img1 },
    { id: '/img/dashboard/dashboard-image2.jpg', src: img2 },
    { id: '/img/dashboard/dashboard-image3.jpg', src: img3 },
    { id: '/img/dashboard/dashboard-image4.jpg', src: img4 },
    { id: '/img/dashboard/dashboard-image5.jpg', src: img5 },
    { id: '/img/dashboard/dashboard-image6.jpg', src: img6 },
    { id: '/img/dashboard/dashboard-image7.jpg', src: img7 },
    { id: '/img/dashboard/dashboard-image8.jpg', src: img8 },
    { id: '/img/dashboard/dashboard-image9.jpg', src: img9 },
    { id: '/img/dashboard/dashboard-image10.jpg', src: img10 },
];

export const WORKSPACE_DEFAULT_COVER = icons;

export const INSIGHTS_DEFAULT_COVER = insightsCover;

export const FEED_TYPE_MAP = {
    'FOLDER': 'monitor',
    'ANALYTICS': 'monitor',
    'DISCOVERY': 'monitor',
    'CHEMICAL': 'monitor',
    'MY_FOLLOW_COMPANY': 'monitor',
    'NEW': 'workCircle',
    'SHARE': 'workCircle',
    'CUSTOM_FIELD': 'workCircle',
    'COMMENT': 'workCircle',
    'GROUP': 'workCircle',
    'MY_COMPANY_PATENT_NEW': 'company',
    'MY_COMPANY_PATENT_LEGAL': 'company',
    'NEWS': 'news',
    'PERSONAL_ACHIEVEMENT_COMPANY': 'points',
    'PERSONAL_ACHIEVEMENT': 'points',
    'DAILY_TASK_COMPANY': 'points',
    'DAILY_TASK': 'points'
};

export const FE_CHEMICAL_URL = CHEMICAL_URI;

export const FE_BIO_URL = BIO_URI;

export const FE_DISCOVERY_URL = DISCOVERY_URI;

export const FE_INSIGHTS_URL = INSIGHTS_URI;

export const FE_ANALYTICS_URI = ANALYTICS_URI;

export const FE_ACCOUNT_URI = ACCOUNT_URI;

export const FE_WORKSPACE_URI = WORKSPACE_URI;

export const FE_DASHBOARD_URI = DASHBOARD_URI;

export const FE_SYNAPSE_URI = SYNAPSE_URI;

export const SEARCH_MAP = {
    'Advanced_Search': {
        type: 'analytics',
        label: 'commonlyUsed.searchType.advanced',
        href: `${FE_ANALYTICS_URI}/search/input/field`,
    },
    'Semantic_Search': {
        type: 'analytics',
        label: 'commonlyUsed.searchType.semantic',
        href: `${FE_ANALYTICS_URI}/search/input/semantic`,
    },
    'Image_Search': {
        type: 'analytics',
        label: 'commonlyUsed.searchType.image',
        href: `${FE_ANALYTICS_URI}/search/input/image`,
    },
    'Bulk_Search': {
        type: 'analytics',
        label: 'commonlyUsed.searchType.bulk',
        href: `${FE_ANALYTICS_URI}/search/input/bulk`,
    },
    'Sequence_Search': {
        type: 'bio',
        label: 'commonlyUsed.searchType.sequence',
        href: `${FE_BIO_URL}/search#/?type=sequence`,
    },
    'Antibody_Search': {
        type: 'bio',
        label: 'commonlyUsed.searchType.antibody',
        href: `${FE_BIO_URL}/search#/?type=antibody`,
    },
    'Motif_Search': {
        type: 'bio',
        label: 'commonlyUsed.searchType.motif',
        href: `${FE_BIO_URL}/search#/?type=motif`,
    },
    'Structure_Search': {
        type: 'chemical',
        label: 'commonlyUsed.searchType.structure',
        href: `${FE_CHEMICAL_URL}/search/#/`,
    },
    'Multi_Structure_Search': {
        type: 'chemical',
        label: 'commonlyUsed.searchType.multiStructure',
        href: `${FE_CHEMICAL_URL}/search/#/multi`,
    },
    'Properties_Search': {
        type: 'chemical',
        label: 'commonlyUsed.searchType.properties',
        href: `${FE_CHEMICAL_URL}/search/#/properties`,
    }
};
